import { IOrderedItemView } from "interfaces/session/ShoppingCart";
import { IReplaceProductsAction } from "../interfaces/shopping-cart.interface";

export function addItemSuccess(itemsInCart: IOrderedItemView[]): IReplaceProductsAction {
  return {
    type: "ADD_ITEM",
    data: itemsInCart,
  };
}
